<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-25 17:51:31
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-23 14:13:10
 -->
<template>
  <div class="centerPart">
    <div id="guardrailMap"></div>
    <div class="platFormIntroduceBtn" @click="detailShowSwitch">平台介绍</div>
    <transition name="el-zoom-in-center">
      <div class="platFormIntroduceDetail" v-if="showDetail">
        <span class="closeBtn el-icon-close" @click="closePdfView"></span>
        <iframe :src="pdfUrl + '#scrollbars=0&toolbar=0&statusbar=0'" frameborder="0" scrolling="no"></iframe>
      </div>
    </transition>
    <!-- 信息窗体 -->
    <div class="deviceDetailInfowindow" ref="deviceDetailInfowindow" v-show="show">
      <span class="closeInfowindow" @click="closeInfowindow">×</span>
      <div class="title">
        <span class="type">{{deviceInfo.typeName}}：</span>
        <span class="name">{{deviceInfo.name}}</span>
      </div>
      <div class="content">
        <div class="item">
          <span class="label">所属机构：</span>
          <span class="value">{{deviceInfo.allotCompanyName}}</span>
        </div>
        <div class="item">
          <span class="label">安装时间：</span>
          <span class="value">{{deviceInfo.installTime}}</span>
        </div>
        <div class="item">
          <span class="label">安装位置：</span>
          <span class="value">{{deviceInfo.installPosition}}</span>
        </div>
        <div class="item">
          <span class="label">安装经纬度：</span>
          <span class="value">{{deviceInfo.installLng}},{{deviceInfo.installLat}}</span>
        </div>
        <div class="item">
          <span class="label">设备状态：</span>
          <span :class="deviceInfo.online ? 'online' : 'offline'">{{deviceInfo.online ? '在线' : '离线'}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timestampFormat } from '@/utils/timestampFormat'
export default {
  name: 'centerPart',
  components: {
  },
  data () {
    return {
      mapStyle: 'amap://styles/ab56ea6d2065aadeee5cb62e09b107a1',
      showDetail: false,
      pdfUrl: 'https://bigdata-v.prod.hndfsj.net/hlpz.pdf',
      cluster: null,
      deviceInfo: {},
      show: false,
    }
  },
  methods: {
    /**
     * @description                   平台介绍详细信息的打开与隐藏
     * @return {undefied}             无返回值
     */
    detailShowSwitch () {
      this.showDetail = !this.showDetail
    },
    /**
     * @description                   关闭平台介绍
     * @return {undefied}             无返回值
     */
    closePdfView () {
      this.showDetail = false
    },
    /**
     * @description                   关闭信息窗体
     * @return {undefied}             无返回值
     */
    closeInfowindow () {
      this.show = false
      window.deviceDetailInfowindow.close()
    },
    /**
     * @description: 初始化信息窗体
     * @return {undefined} 无返回值
     */
    createInfowidnow () {
      // eslint-disable-next-line no-undef
      window.deviceDetailInfowindow = new AMap.InfoWindow({
        autoMove: false,
        // closeWhenClickMap: true,
        isCustom: true, // 使用自定义窗体
        content: this.$refs.deviceDetailInfowindow,
        // eslint-disable-next-line no-undef
        offset: new AMap.Pixel(0, -65),
      })
    },
    /**
     * @description: 初始化地图
     * @param {undefined}
     * @return {undefined} 无返回值
     */
    initMap () {
      // eslint-disable-next-line no-undef
      let map = new AMap.Map('guardrailMap', {
        // zoom: 10,
        // center: [113.679865, 34.760179],
        // viewMode: '3D',
        // skyColor: '#87CEEB',
        // pitch: 60,
        mapStyle: this.mapStyle,
        animateEnable: true,
      })
      window.mapInstance = map
      this.createInfowidnow()
      this.getDeviceData()
    },
    /**
     * @description: 获取设备数据
     * @return {undefined} 无返回值
     */
    getDeviceData () {
      let self = this
      this.$http.get('/rest/screen/hlpz/device/list')
        .then(res => {
          if (res.code === 0) {
            // let markers = []
            res.data.map(item => {
              item.installTime = timestampFormat('YYYY-mm-dd HH:MM:SS', new Date(item.installTime))
              // eslint-disable-next-line no-undef
              let marker = new AMap.Marker({
                position: [item.installLng, item.installLat],
              })
              // eslint-disable-next-line no-undef
              AMap.event.addListener(marker, 'click', function (e) {
                self.deviceInfo = item
                window.mapInstance.panTo([parseFloat(item.installLng), parseFloat(item.installLat) + 0.003])
                window.mapInstance.setZoom(16)
                window.deviceDetailInfowindow.open(window.mapInstance, [parseFloat(item.installLng), parseFloat(item.installLat)])
                self.show = true
              })
              // markers.push(marker)
              window.mapInstance.add(marker)
            })
            // eslint-disable-next-line no-undef
            // this.cluster = new AMap.MarkerClusterer(window.mapInstance, markers, { gridSize: 80 })
            window.mapInstance.setFitView()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  mounted () {
    this.initMap()
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .centerPart {
    width: 100%;
    height: 100%;
    position: relative;
    #guardrailMap {
      width: 100%;
      height: 75%;
      border-radius: 10px;
    }
    .platFormIntroduceBtn {
      width: 17%;
      height: 8%;
      background: url('/static/img/layout/platformIntroduceBg.png');
      background-size: 100% 100%;
      position: absolute;
      bottom: 15%;
      left: 0;
      text-align: center;
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 1.8vh;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
    }
    .platFormIntroduceDetail {
      width: 800px;
      height: 800px;
      padding-top: 30px;
      overflow-y: scroll;
      position: absolute;
      top: -50px;
      left: 130px;
      color: #d7fdff;
      font-size: 18px;
      line-height: 24px;
      z-index: 10000;
      .closeBtn {
        display: inline-blockl;
        width: 20px;
        height: 20px;
        cursor: pointer;
        font-size: 30px;
        position: absolute;
        right: 5px;
        top: 0;
        z-index: 10000000;
      }
      iframe {
        width: 100%;
        height: calc(100% - 20px);
        border-radius: 10px;
        ::-webkit-scrollbar-thumb {
          cursor: pointer;
          box-shadow: inset 0 0 6px #106669;
          background-color: #05dbe3;
          border-radius: 4px;
        }

        ::-webkit-scrollbar:hover {
          width: 5px;
          height: 10px;
        }

        ::-webkit-scrollbar-corner {
          background-color: #181f27;
        }
      }
    }
    .deviceDetailInfowindow {
      width: 400px;
      height: 200px;
      padding: 20px;
      background: url('/static/img/layout/listBg.png');
      background-size: 100% 100%;
      position: relative;
      .closeInfowindow {
        font-size: 20px;
        color: #fff;
        cursor: pointer;
        position: absolute;
        display: inline-block;
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        right: 20px;
        top: 10px;
      }
      .title {
        width: 100%;
        height: 30px;
        font-size: 16px;
        font-weight: bold;
        color: #05dbe3;
        border-bottom: 1px solid #376668;
      }
      .item {
        line-height: 30px;
        .label {
          font-size: 14px;
          color: #eee;
          display: inline-block;
          width: 86px;
          text-align: right;
        }
        .value {
          font-size: 14px;
          color: rgb(192, 192, 192);
        }
        .online {
          font-size: 14px;
          color: rgb(0, 255, 0);
        }
        .offline {
          font-size: 14px;
          color: rgb(235, 77, 111);
        }
      }
    }
  }
</style>
